let PlacesService = require('./places-service');

module.exports = {
  PlacesService
};
